import { jsx as e } from "react/jsx-runtime";
//#region lib/List/components/ListItem.tsx
var t = ({ children: t }) => /* @__PURE__ */ e("div", {
	className: "list-item pl-4",
	children: t
});
//#endregion
export { t as ListItem };
